import { createContext, useContext } from "react";

import { createStore, useStore } from "zustand";

type PreviewState = {
  workbookId: string | null;
  tableId: string | null;
  roleKey: string | null;
  targetYear: "CURRENT" | "PREVIOUS";
  dimension: "LINE_ITEM" | "AXIS";
  setWorkbookId: (workbookId: string) => void;
  setTableId: (tableId: string) => void;
  setRoleKey: (roleKey: string) => void;
  setDimension: (dimension: "LINE_ITEM" | "AXIS") => void;
  setTargetYear: (targetYear: "CURRENT" | "PREVIOUS") => void;
};

export const createPreviewStore = (
  init?: Partial<Pick<PreviewState, "workbookId" | "tableId">>,
) =>
  createStore<PreviewState>()((set) => ({
    workbookId: init?.workbookId ?? null,
    tableId: init?.tableId ?? null,
    roleKey: null,
    targetYear: "CURRENT" as const,
    dimension: "LINE_ITEM" as const,
    setDimension: (dimension) => set({ dimension }),
    setTargetYear: (period) => set({ targetYear: period }),
    setWorkbookId: (workbookId) => set({ workbookId }),
    setTableId: (tableId) => set({ tableId }),
    setRoleKey: (roleKey) => set({ roleKey }),
  }));

export const PreviewStoreContext = createContext<ReturnType<
  typeof createPreviewStore
> | null>(null);

export const usePreviewStore = <T>(selector: (state: PreviewState) => T): T => {
  const store = useContext(PreviewStoreContext);

  if (!store) {
    throw new Error("Missing PreviewStoreProvider in the component tree");
  }

  return useStore(store, selector);
};
